import { useFormSetDeliveryTimeField } from '@/features/pos/components/OrderFinalization/form'
import { Time } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'
import { useCallback, useState } from 'react'

export const useTime = (times: Time[]): [string | null, (index: string | null) => void] => {
    const [index, setIndex] = useState<string | null>(null)

    const setDeliveryTime = useFormSetDeliveryTimeField()

    const handleChange = useCallback(
        (index: string | null) => {
            setIndex(index)

            const time = index ? times[Number(index)] : null

            setDeliveryTime(time)
        },
        [times, setDeliveryTime]
    )

    return [index, handleChange]
}
